import { Button, Card, ControlledInput, HoverDetails } from "@dune/ui";
import { Loader2, Save } from "lucide-react";
import React from "react";
import { FormProvider } from "react-hook-form";
import { useParams } from "react-router-dom";
import {
	AccountingFormData,
	useAccountingTab,
} from "./accountingTab/useAccountingTab";

const AccountingTab: React.FC = () => {
	const { id } = useParams<{ id: string }>();

	const { form, isLoading, error } = useAccountingTab(Number(id));

	const {
		formState: { errors },
		control,
		handleSubmit,
	} = form;

	const onSubmit = (data: AccountingFormData) => {
		console.log("Accounting data:", data);
	};

	if (isLoading) {
		return (
			<div className="flex items-center justify-center p-8">
				<Loader2 className="h-8 w-8 animate-spin" />
			</div>
		);
	}

	if (error) {
		return (
			<div className="flex items-center justify-center p-8 text-red-600">
				Erreur lors du chargement des données comptables
			</div>
		);
	}
	return (
		<FormProvider {...form}>
			<div className="flex flex-col gap-4 py-4">
				<div className="flex flex-row w-full">
					<div className="w-full flex items-center">
						<div className="text-text-main-blue font-semibold flex justify-center items-center ">
							Coordonnées bancaires
							<HoverDetails
								content={
									<div>
										Pour toute modification des informations société, <br />
										envoyer un email à l'adresse
										<span className="underline">contact@duneassurance.com</span>
									</div>
								}
							/>
						</div>
					</div>
					<div className="w-full flex items-center">
						<div className="text-text-main-blue font-semibold ml-2">
							Contact
						</div>
					</div>
				</div>
				<div className="flex flex-row gap-4 pb-3">
					<div className="w-full flex flex-col gap-4">
						<Card className="p-6 flex flex-col gap-4 overflow-auto text-text-secondary-blue">
							<ControlledInput
								label="IBAN"
								control={control}
								name="iban"
								error={errors.iban?.message?.toString()}
								disabled
								className="disabled:bg-gray-100 disabled:text-gray-600 border:bg-gray-900"
							/>
							<ControlledInput
								label="BIC/SWIFT"
								control={control}
								name="bic"
								error={errors.bic?.message?.toString()}
								disabled
								className="disabled:bg-gray-100 disabled:text-gray-600 border:bg-gray-900"
							/>
						</Card>
					</div>
					<div className="w-full flex flex-col gap-4">
						<Card className="p-6 flex flex-col gap-4 overflow-auto text-text-secondary-blue">
							<div className="flex flex-row gap-4">
								<ControlledInput
									label="Nom"
									control={control}
									name="executiveLastname"
									error={errors.executiveLastname?.message?.toString()}
								/>
								<ControlledInput
									label="Prénom"
									control={control}
									name="executiveFirstname"
									error={errors.executiveFirstname?.message?.toString()}
								/>
							</div>
							<ControlledInput
								label="Email"
								control={control}
								name="executiveEmail"
								error={errors.executiveEmail?.message?.toString()}
							/>
						</Card>
					</div>
				</div>
				<div className="flex justify-end">
					<Button
						onClick={handleSubmit(onSubmit)}
						className="flex items-center gap-2"
					>
						<Save className="h-4 w-4" />
						Sauvegarder
					</Button>
				</div>
			</div>
		</FormProvider>
	);
};

export default AccountingTab;
